import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: any = [];

export const contractDetailDataSlice = createSlice({
 name: 'contractDetailData',
 initialState,
 reducers: {
  contractDetailData: (state, action: PayloadAction<any>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { contractDetailData } = contractDetailDataSlice.actions;

export default contractDetailDataSlice.reducer;
